import { SET_CREDENCIAL } from '../actions/actionTypes';
import { BASE_NAME } from '../constants/index.js';

/*
 * Credencial da área pública: emitida pelo back na identificação e renovada a
 * cada resposta (header `credencial`). Fica no Redux, que o async.js já envia
 * em toda chamada, e no sessionStorage, para sobreviver ao F5 na mesma aba
 * (some ao fechar a aba). O valor já vem codificado do back: vai como está,
 * sem o encodeURIComponent do setCredencial.
 *
 * No administrativo a credencial é a do colaborador, vinda do portal na URL:
 * a renovação continua indo para o Redux, mas não para o sessionStorage da
 * área pública (nem é lida de lá).
 */
const CHAVE = 'sysbeneficio.credencialPublica';
const AREA_ADMINISTRATIVA = `${BASE_NAME}/administrativo`;
export const EVENTO_CREDENCIAL_EXPIRADA = 'sysbeneficio:credencial-expirada';

export const estaNaAreaAdministrativa = () => {
    try {
        const pathname = window.location.pathname;
        return pathname === AREA_ADMINISTRATIVA || pathname.startsWith(`${AREA_ADMINISTRATIVA}/`);
    } catch (e) {
        return false;
    }
};

let dispatch = null;

/* O store registra o dispatch ao ser criado (evita importar o store aqui e criar ciclo). */
export const registrarDispatchCredencial = storeDispatch => {
    dispatch = storeDispatch;
};

export const lerCredencialGuardada = () => {
    try {
        return window.sessionStorage.getItem(CHAVE) || '';
    } catch (e) {
        return '';
    }
};

export const guardarCredencial = credencial => {
    if (!credencial) return;
    if (!estaNaAreaAdministrativa()) {
        try {
            window.sessionStorage.setItem(CHAVE, credencial);
        } catch (e) {
            // Sem sessionStorage (aba privada/bloqueio): segue só no Redux.
        }
    }
    dispatch && dispatch({ type: SET_CREDENCIAL, credencial });
};

export const limparCredencial = () => {
    try {
        window.sessionStorage.removeItem(CHAVE);
    } catch (e) {
        // Sem sessionStorage: nada a limpar.
    }
    dispatch && dispatch({ type: SET_CREDENCIAL, credencial: '' });
};

/* Credencial recusada pelo back (401): limpa e avisa a aplicação para voltar à identificação. */
export const credencialExpirada = mensagem => {
    limparCredencial();
    window.dispatchEvent(new CustomEvent(EVENTO_CREDENCIAL_EXPIRADA, { detail: mensagem }));
};
